"use client";

import { useEffect, useRef } from "react";

// The legacy editor shares the shell's leave store (@/utils/editor-unsaved-guard), so
// navigation, logout and shop switching still prompt. Only its "Save and exit" is its own.
type SaveAndExitHandler = () => Promise<boolean>;

let saveAndExitHandler: SaveAndExitHandler | null = null;

export function getSaveAndExitHandler() {
  return saveAndExitHandler;
}

/** Keeps a stable registration while always calling the latest save handler. */
export function useRegisterSaveAndExitHandler(handler: SaveAndExitHandler) {
  const handlerRef = useRef(handler);
  handlerRef.current = handler;

  useEffect(() => {
    saveAndExitHandler = () => handlerRef.current();
    return () => {
      saveAndExitHandler = null;
    };
  }, []);
}
